module.exports = {"year":"{0}г","month":"{0}мес","week":"{0}нед","day":"{0}д","hour":"{0}ч","minute":"{0}м","second":"{0}с"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/locale-more-styles/ru/tiny.json
// module id = 692
// module chunks = 0